import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ColorPickerDirective } from 'ngx-color-picker';
import { Course } from 'src/app/models/course';
import { CoursesService } from 'src/app/services/courses/courses.service';
import { CourseEnrollment} from 'src/app/models/course-enrollment';

@Component({
  selector: 'li-course-edit',
  templateUrl: './course-edit.component.html',
  styleUrls: ['./course-edit.component.scss'],
  standalone: true,
  imports: [FormsModule, CommonModule, ColorPickerDirective]
})
export class CourseEditComponent implements OnChanges {
    @Input()
    public course?: Course;

    @Input() students: CourseEnrollment[] = [];

    @Output()
    public closing = new EventEmitter();

    public model: Course = {} as Course;

    constructor(private coursesService: CoursesService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['course']) {
        if (this.course) {
            this.model = { ...this.course };

            if (this.model.color && !this.model.color.startsWith('#')) {
            this.model.color = '#' + this.model.color;
            }
        } 
        else {
            this.model = {
            cid: 0,
            name: '',
            diffname: '',
            description: '',
            level: '',
            link: '',
            color: '#000000',
            age_begin: 0,
            age_end: 0,
            students: []
            };
        }
        }
    }


    public close(): void {
        this.closing.emit();
    }

    public save(): void {
        const saveModel: Course = { ...this.model };

        if (saveModel.color?.startsWith('#')) {
            saveModel.color = saveModel.color.substring(1);
        }

        this.sanitize(saveModel);

        this.coursesService.set(saveModel).subscribe(() => {
            this.closing.emit();
        });
    }

    public visibility(): string {
        return this.course ? 'show' : 'hidden';
    }

    private sanitize(course: Course): Course {
        if (course) {
            course.name ??= '';
            course.diffname ??= '';
            course.description ??= '';
            course.level ??= '';
            course.age_begin ??= 0;
            course.age_end ??= 0;
            course.link ??= '';
            course.color ??= '';
        }

        return course;
    }
}
